import { Note } from '@api';
import { Dialog } from '@mui/material';
import NoteForm from './NoteForm';

type NoteDialogProps = {
  open: boolean;
  onClose: () => void;
  note?: Note;
  noteBoardId: number;
  notes: Note[];
};

const NoteDialog = ({ open, onClose, note, noteBoardId, notes }: NoteDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="board-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'md'}
    >
      <NoteForm note={note} onClose={onClose} noteBoardId={noteBoardId} notes={notes} />
    </Dialog>
  );
};

export default NoteDialog;
